<template>
  <div class="appContainer">
    <MyMap :locations="locations" @clicked="getNetwork($event)" />
    <Infocard :networksArray="networks" :countriesObj="countries" />
  </div>
</template>

<script>
import Infocard from "./Infocard";
import MyMap from "./MyMap";
import { cases } from "../shared";

export default {
  name: "MapController",
  components: {
    Infocard,
    MyMap
  },
  data: function() {
    return {
      locations: {},
      networks: [],
      countries: {}
    };
  },
  mounted: async function() {
    [this.locations, this.networks, this.countries] = await cases.getTable();
  },computed:{},
  methods: {

  }
};
</script>

<style lang="scss" scoped >
.appContainer {
  display: flex;
}
</style>